<div class="relative rounded-lg shadow-sm font-title font-medium text-sm">
  <select
    class="h-11 w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-11 text-sm shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800
      {{
      value()
        ? 'text-gray-800 dark:text-white/90'
        : 'text-gray-400 dark:text-gray-400'
    }} {{ className() }}"
    [ngModel]="value()"
    (change)="onChange($event)"
    [disabled]="disabled()"
  >
    <!-- Placeholder option -->
    @if (options().length === 0) {
      <option
        value=""
        disabled
        [selected]="true"
        class="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
      >
        {{ placeholder() }}
      </option>
    }
    <!-- Map over options -->
    @for (option of options(); track $index) {
    <option
      [value]="option.value"
      class="text-gray-700 dark:bg-gray-900 dark:text-gray-400"
    >
      {{ option.label }}
    </option>
    }
  </select>
  <!-- Dropdown caret icon -->
  <svg
    class="absolute text-gray-700 dark:text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.79175 8.02075L10.0001 13.2291L15.2084 8.02075"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</div>
